import React from "react";

import { ProgressBar } from "react-bootstrap";
import "../../../styles/pages-styles/main-dashboard-pages-styles/knowledge-pages-styles/KnowledgeTutor.css";
import QuestionDropDown from "../../../components/question-components/QuestionDropDown";
// import CategoriesPanel from "../../../components/knowledge-components/CategoriesPanel";
// import CustomAccordion from "../../../components/knowledge-components/CustomAccordion";


const KnowledgeTutor = () => {
  return (
    <div className="knowledge-tutor-container">
      <div className="knowledge-tutor-header">
        <div className="knowledge-tutor-header-content">
          <div className="knowledge-tutor-header-text">
            <p>
              The knowledge tutor is a collection of thousands of high-yield
              exam facts powered by an ANKI-style spaced repetition system. Our
              algorithms turn these facts into mini-questions that are
              constantly evolving, ensuring the most important facts are given
              the highest priority.
            </p>
            <button>More</button>
          </div>

          <div className="knowledge-tutor-progress">
            <p>
              You've been tested on 9% (103/1134) of A++ to A facts. Acceptable
              recall has been achieved in 72% of these facts{" "}
              <a href="#">more</a>
            </p>
            
          </div>
        </div>

        <div className="knowledge-tutor-start-section">
          <button className="knowledge-tutor-start-button">
            
            <a href="/knowledgeexam">Start the Knowledge tutor</a>
            
          </button>
          <p className="knowledge-tutor-facts-count">1,885 facts found</p>
        </div>
      </div>

      <div className="knowledge-tutor-main-content">
        <div className="knowledge-tutor-categories">
          {/* <CategoriesPanel /> */}

          <div className="knowledge-tutor-card">
            <h5>HIGH-YIELD RATING</h5>
            <QuestionDropDown />
            {/* <CustomAccordion /> */}
          </div>

          <div className="knowledge-tutor-card">
            <h5>DIFFICULTY RATING</h5>
            <div className="difficulty-slider">
              <input type="range" min="0" max="100" className="form-range" />
              <div className="difficulty-slider-label">
                <span>Easy</span>
                <span>Hard</span>
              </div>
            </div>
            {/* <CustomAccordion /> */}
          </div>

          <div className="knowledge-tutor-card">
            <h5>FACT SELECTION</h5>
            <QuestionDropDown placeholder="Spaced repetition (individual facts)" />
            {/* <CustomAccordion /> */}
          </div>
        </div>

        <div className="knowledge-tutor-sidebar">
          <h5 className="recent-sessions-title">RECENT SESSIONS</h5>

          <div className="recent-session-item">
            <div className="recent-session-details">
              <p>All categories (ALL - 0-100)</p>
              <p>4 days ago</p>
            </div>
            <button className="recent-session-continue">Continue</button>
          </div>

          <div className="recent-session-item">
            <div className="recent-session-details">
              <p>Psychiatry (ALL - 0-100)</p>
              <p>5 days ago</p>
            </div>
            <button className="recent-session-continue">Continue</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeTutor;
